import React, { useState, useEffect } from "react";
import { userInfoField } from "@/config/config";
import { UserOutlined, DownOutlined } from "@ant-design/icons";
import { Avatar, Dropdown, Divider } from "antd";
import { LogoutOutlined } from "@ant-design/icons";
import type { MenuProps } from "antd";
import { Link } from "react-router-dom";

const userInfo = JSON.parse(sessionStorage.getItem(userInfoField) as any);

const Component = (props: any) => {
  const logout = () => {
    sessionStorage.removeItem(userInfoField);
    window.location.href = "/";
  };

  const items: MenuProps["items"] = [
    // {
    //   key: 'userInfo',
    //   label: (
    //     <Link to='/user/info'>
    //       我的资料
    //     </Link>
    //   ),
    // },
    {
      key: "logout",
      danger: true,
      label: (
        <div onClick={logout} style={{ padding: "5px 10px" }}>
          <LogoutOutlined /> 退出
        </div>
      ),
    },
  ];

  return (
    <div className="userPanel">
      <Dropdown menu={{ items }} arrow placement="bottomRight">
        <div className="userPanelTrigger">
          <Avatar
            className="userPanelAvatar"
            size={20}
            icon={<UserOutlined />}
          />
          {/* 用户名称 */}
          {userInfo?.username ? (
            <span className="userPanelName" title={userInfo.username}>
              {userInfo.username}
            </span>
          ) : null}
          <DownOutlined className="userPanelArrow" />
        </div>
      </Dropdown>
    </div>
  );
};

export default Component;
